import { render } from "./visibility-circle.svg?vue&type=template&id=bea1e374?inline"
const script = {}
script.render = render

export default script